// Customer-loyalty pivot — the contract for the per-shop member code as it
// travels through a scannable QR / barcode.
//
// The member's wallet renders a QR encoding `encodeMemberQr(code)`; the
// register's scan classifier (slice 2) recognises any scanned string with
// the MEMBER_QR_PREFIX as a member code (never a product barcode) and pulls
// the bare code back out with `parseMemberQr`. Keeping both sides in one
// module means the prefix can never drift between producer and consumer.

export const MEMBER_QR_PREFIX = 'PAM:';

// Wrap a bare member code in the namespaced payload the wallet QR encodes.
export function encodeMemberQr(code: string): string {
  return `${MEMBER_QR_PREFIX}${code.trim().toUpperCase()}`;
}

// Return the bare member code if `raw` is a member-QR payload, else null.
// Case-insensitive on the prefix; the returned code is normalised upper-case
// to match how codes are stored/indexed server-side.
export function parseMemberQr(raw: string): string | null {
  const t = raw.trim();
  if (t.length <= MEMBER_QR_PREFIX.length) return null;
  if (t.slice(0, MEMBER_QR_PREFIX.length).toUpperCase() !== MEMBER_QR_PREFIX)
    return null;
  const code = t.slice(MEMBER_QR_PREFIX.length).trim().toUpperCase();
  return code.length > 0 ? code : null;
}
